/** Numéro utilisable pour SMS / WhatsApp (non vide après trim). */
export function hasUsableClientPhone(phone: string | undefined | null): boolean {
  return typeof phone === 'string' && phone.trim().length > 0;
}
